import { useRef, useState, useEffect, useMemo } from 'react';
import { UserReferralModel } from '../../models';
import { getFriendlyPublicName, getMembershipStyle } from '../../utils';
import { Avatar } from '../ui';
import './ReferralList.css';
import { MEMBERSHIP_TYPE } from '../../enums';

export function ReferralList(props: { userReferrals: UserReferralModel[] }) {
   const { userReferrals } = props;

   const level0Ref = useRef<HTMLDivElement>(null);
   const level1Ref = useRef<HTMLDivElement>(null);
   const level2Ref = useRef<HTMLDivElement>(null);

   const [widths, setWidths] = useState({
      level0: 0,
      level1: 0,
      level2: 0,
   });

   useEffect(() => {
      const calculateWidths = () => {
         setWidths({
            level0: level0Ref.current?.clientWidth || 0,
            level1: level1Ref.current?.clientWidth || 0,
            level2: level2Ref.current?.clientWidth || 0,
         });
      };

      // Measure widths on mount and when the window is resized
      calculateWidths();
      window.addEventListener('resize', calculateWidths);

      return () => window.removeEventListener('resize', calculateWidths);
   }, []);

   return (
      <div className="referral-list flex flex-col gap-4 pt-5">
         <div className="referral-list-header flex items-center gap-2">
            <div className="flex-1">
               <h2>Referrals</h2>
            </div>
            <div className="flex-3 flex gap-1">
               <div className="flex-1 flex justify-start items-center">
                  <span
                     className="gray medium text-center"
                     ref={level0Ref}>
                     Signed Up
                  </span>
               </div>
               <div className="flex-1 flex justify-center items-center">
                  <span
                     className="gray medium text-center"
                     ref={level1Ref}>
                     Profiles Completed
                  </span>
               </div>
               <div className="flex-1 flex justify-end items-center">
                  <span
                     className="gray medium text-center"
                     ref={level2Ref}>
                     Purchased Memberships
                  </span>
               </div>
            </div>
         </div>
         <div className="referral-list-body flex flex-col gap-3">
            {userReferrals.map((referral) => (
               <div
                  key={referral.user.id}
                  className="referral-list-item flex items-center gap-2">
                  <div className="flex-1 flex items-center gap-2 wrap">
                     <Avatar
                        imageUrl={referral.user.image ?? null}
                        size={45}
                     />
                     <span className="nowrap">{getFriendlyPublicName(referral.user)}</span>
                  </div>
                  <div className="flex-3 flex gap-1 relative">
                     {Array.from({ length: 3 }).map(
                        (_, index) =>
                           index > 0 && (
                              <div
                                 key={'referral-list-item-progress' + index}
                                 className={`referral-list-item-progress flex-1 ${index > 0 && index <= referral.level ? 'active' : ''}`}
                                 style={{
                                    marginLeft: index === 1 ? `${widths.level0 / 2}px` : '0px',
                                    marginRight: index === 2 ? `${widths.level2 / 2}px` : '0px',
                                 }}
                              />
                           )
                     )}

                     {Array.from({ length: 3 }).map((_, index) => (
                        <div
                           className={`referral-level-box-container flex flex-1 justify-center index-${index}`}
                           key={'referral-list-item-level' + index}
                           style={{
                              transform:
                                 index === 0
                                    ? `translateX(calc(${widths.level0 / 2}px - 50%)) translateY(-50%)`
                                    : index === 2
                                    ? `translateX(calc(-${widths.level2 / 2}px + 50%)) translateY(-50%)`
                                    : 'translateY(-50%) translateX(-50%)',
                           }}>
                           <div className={`referral-level-box bg-gray flex items-center ${index <= referral.level ? 'active' : ''}`}>
                              {/* <img
                                 src={`/assets/icons/${index === 1 ? 'ball' : 'ticket'}-icon.svg`}
                                 alt=""
                              /> */}

                              {index === 0 && (
                                 <img
                                    src={`/assets/icons/ticket-icon.svg`}
                                    alt=""
                                 />
                              )}

                              {index === 1 && (
                                 <img
                                    src={`/assets/icons/ball-icon.svg`}
                                    alt=""
                                 />
                              )}
                              {index === 2 && (
                                 <img
                                    src={getMembershipStyle(referral.membershipTypeBonus ?? MEMBERSHIP_TYPE.DIAMOND).icon}
                                    alt=""
                                 />
                              )}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            ))}
         </div>
      </div>
   );
}
